<template>
  <a-row class="content-fix org">
    <!-- <a-button
      style="margin-top: 15px"
      type="primary"
      class="org back-btn"
      @click="$router.push({ name: 'pressCenter' })"
    >
      <i class="t-transition icons icon-chevron-left" />
      Назад
    </a-button> -->
    <a-row class="content-title" type="flex">
      <h2>FAQ</h2>
      <a-button
        style="margin-left: auto"
        type="primary"
        @click="$router.push({ name: 'faq-ThemeCreate' })"
      >
        <a-icon type="plus" />{{ $t("Add") }}
      </a-button>
      <a-button
        :disabled="cardsIsEmpty"
        type="danger"
        style="margin-left: 10px"
        @click="removeItem(selectedPosts)"
      >
        <a-icon class="action-btns" type="delete" />
        <!--{{ $t("Delete") }}-->
      </a-button>
    </a-row>

    <a-table
      class="faqs"
      :columns="columns"
      :data-source="form"
      :loading="loading"
      :pagination="false"
      :scroll="{ x: 1800, y: 600 }"
      :row-key="(record) => record.id"
    >
      <template slot="id" slot-scope="item">
        <a-checkbox
          style="padding-right: 10px"
          :checked="selectedPosts.includes(+item.id)"
          :value="+item.id"
          @change="toggleItemId(item.id)"
        />
        <b>{{ item.id }}</b>
      </template>

      <template slot="order" slot-scope="item">
        <a-input-number
          v-model="item.order"
          style="width: 60px; margin-right: 10px"
          :min="1"
          @pressEnter="updatePosition(item, $event)"
        />
      </template>

      <template slot="theme" slot-scope="item">
        <span
          class="td-post-item"
          @click="
            $router.push({ name: 'faq-ThemeDetail', params: { id: item.id } })
          "
        >
          {{ item.title || "Не заполнено" }}
        </span>
      </template>

      <template slot="question" slot-scope="item">
        <a-button
          style="margin-right: 10px"
          type="primary"
          @click="
            $router.push({
              name: 'faq-ques',
              params: { theme_id: item.id }
            })
          "
        >
          {{ $t("Add") }}
        </a-button>
      </template>

      <template slot="status" slot-scope="item">
        <a-tag :color="item.is_active ? 'geekblue' : 'volcano'">
          {{ item.is_active ? $t("Published") : $t("NotPublished") }}
        </a-tag>
      </template>

      <template slot="created_at" slot-scope="item">
        {{ moment(item.created_at).format("LLL") }}
      </template>

      <template slot="updated_at" slot-scope="item">
        {{ moment(item.updated_at).format("LLL") }}
      </template>

      <template slot="operation" slot-scope="item">
        <a-button
          type="primary"
          class="edit-btn"
          @click="
            $router.push({ name: 'faq-ThemeDetail', params: { id: item.id } })
          "
        >
          <a-icon class="action-btns" type="edit" />
          <!--{{ $t("Edit") }}-->
        </a-button>
        <a-popconfirm
          cancel-text="Нет"
          ok-text="Да"
          title="Вы действительно хотите удалить?"
          @confirm="removeItem(item.id)"
        >
          <a-button type="danger">
            <a-icon class="action-btns" type="delete" />
            <!--{{ $t("Delete") }}-->
          </a-button>
        </a-popconfirm>
      </template>
    </a-table>

    <a-row class="mt-1" style="padding-bottom: 15px">
      <a-pagination
        :key="limit"
        :current="page"
        :default-page-size="limit"
        :total="count || 0"
        @change="setPage"
      />
    </a-row>
  </a-row>
</template>

<script>
export default {
  data() {
    return {
      form: [],
      loading: false,
      columns: [
        {
          title: "ID",
          key: "id",
          width: "90px",
          fixed: "left",
          scopedSlots: { customRender: "id" }
        },
        {
          title: this.$t("Order"),
          key: "order",
          width: "90px",
          fixed: "left",
          scopedSlots: { customRender: "order" }
        },
        {
          title: this.$t("QuestionTheme"),
          key: "theme",
          width: "80%",
          scopedSlots: { customRender: "theme" }
        },
        {
          title: this.$t("Question"),
          key: "question",
          width: "20%",
          scopedSlots: { customRender: "question" }
        },
        {
          title: this.$t("Status"),
          key: "status",
          width: "20%",
          scopedSlots: { customRender: "status" }
        },
        {
          title: this.$t("TableCreatedDate"),
          key: "created_datetime",
          width: "30%",
          scopedSlots: { customRender: "created_at" }
        },
        {
          title: this.$t("TableLastUpdatedDate"),
          key: "updated_datetime",
          width: "30%",
          scopedSlots: { customRender: "updated_at" }
        },
        {
          title: this.$t("TableAction"),
          key: "operation",
          fixed: "right",
          scopedSlots: { customRender: "operation" }
        }
      ],
      selectedRowKeys: [],
      selectedPosts: [],
      cardsIsEmpty: true,
      page: 1,
      limit: 10,
      offset: 0,
      count: 0
    }
  },
  watch: {
    $route: {
      handler: "fetchData",
      immediate: true
    }
  },
  methods: {
    setPage(pageNumber) {
      this.$router.push({ query: { ...this.$route.query, page: pageNumber } })
    },
    toggleItemId(itemId) {
      const f = this.selectedPosts.findIndex((item) => +item === +itemId)
      if (f !== -1) {
        this.selectedPosts.splice(f, 1)
        this.cardsIsEmpty = false
      } else {
        this.selectedPosts.push(itemId)
        this.cardsIsEmpty = false
      }

      if (this.selectedPosts.length === 0) {
        this.cardsIsEmpty = true
      }
    },
    async fetchData() {
      this.loading = true
      this.offset = +this.$route.query.page || 1
      this.page = this.offset
      this.offset = (this.offset - 1) * this.limit
      try {
        const form = await this.$store.dispatch("faq/fetchTheme", {
          params: {
            limit: this.limit,
            offset: this.offset
          }
        })
        this.form = form.results
        this.count = form.count
        this.loading = false
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    },
    async removeItem(id) {
      if (Array.isArray(id)) {
        for (let i of id) {
          try {
            await this.$store.dispatch("faq/removeThemeAction", i)
            this.$message.success("Успешно удалено")
          } catch (e) {
            this.$sentry.captureMessage(e)
          }
        }
      } else {
        try {
          await this.$store.dispatch("faq/removeThemeAction", id)
          this.$message.success("Успешно удалено")
        } catch (e) {
          this.$sentry.captureMessage(e)
        }
      }
      await this.fetchData()
      this.selectedCards = []
      this.cardsIsEmpty = true
    },
    updatePosition(node, event) {
      this.loading = true
      this.$api
        .patch(`/admin/faq/theme/${node.id}/update/`, {
          order: event.target.value
        })
        .then(() => {
          this.loading = false
          this.$message.success("Позиция обновлена")
          this.fetchData()
        })
        .catch((err) => {
          this.loading = false
          this.$message.error(err.message)
        })
    }
  }
}
</script>

<style>
/* .faqs .ant-table-thead > tr:first-child > th:last-child{
  text-align: end;
}
.faqs .ant-btn-primary {
  background-color: #26a6de;
}
 */
</style>
